import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Grid,
  TextField,
} from "@mui/material";
import { IAcronymFormProps } from "../../../interfaces/admin/IAcronymForm";
import { actionTypes } from "../../../store/actionTypes/actionTypes";
import { COMMON } from "../../../constants/common";
import { ADMIN } from "../../../constants/admin";
import { AcronymReducerState } from "../../../interfaces/store/acronymReducerState";
import {
  postDataFromApi,
  putDataFromApi,
} from "../../../services/api/apiService";
import { RestfulUrls } from "../../../constants/restfulUrls";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AcronymForm: React.FC<IAcronymFormProps> = ({
  handleDialogClose,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formLoading, setFormLoading] = useState(false);

  const [formData, setFormData] = useState({
    acronym: "",
    fullForm: "",
    id: "",
  });

  const acronymFormType = useSelector(
    (state: { acronym: AcronymReducerState }) =>
      state.acronym.acronymFormType
  );
  const editFormData = useSelector(
    (state: { acronym: AcronymReducerState }) =>
      state.acronym.acronymSelectedRowData
  );

  const handleChange = (field: string, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (acronymFormType === ADMIN.MEETING_FORM_TYPE.EDIT) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  const handleUpdate = async () => {
    const url = `${RestfulUrls.BASE_URL}${RestfulUrls.EDIT_ACRONYM}`;
    const payloadData = { ...formData };
    setFormLoading(true);
    await putDataFromApi<any>(
      url,
      payloadData,
      () => {
        dispatch({
          type: COMMON.SHOW_SNACKBAR,
          payload: {
            message: "Acronym updated successfully.",
            severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
          },
        });
        dispatch({
          type: actionTypes.UPDATE_FETCH_ACRONYM,
          payload: true,
        });
        handleDialogClose();
        setFormLoading(false);
      },
      { isAuthRequired: true },
      navigate
    );
    setFormLoading(false);
  };

  const handleCreate = async () => {
    const url = `${RestfulUrls.BASE_URL}${RestfulUrls.ADD_ACRONYM}`;
    const payloadData = { ...formData };
    setFormLoading(true);
    await postDataFromApi<any>(
      url,
      payloadData,
      () => {
        dispatch({
          type: COMMON.SHOW_SNACKBAR,
          payload: {
            message: "Acronym created successfully.",
            severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
          },
        });
        dispatch({
          type: actionTypes.UPDATE_FETCH_ACRONYM,
          payload: true,
        });
        handleDialogClose();
        setFormLoading(false);
      },
      { isAuthRequired: true },
      navigate
    );
    setFormLoading(false);
  };

  useEffect(() => {
    if (editFormData) {
      setFormData({
        acronym: editFormData.acronym || "",
        fullForm: editFormData.fullForm || "",
        id: editFormData.id || "",
      });
    } else {
      setFormData({
        acronym: "",
        fullForm: "",
        id: "",
      });
    }
  }, [editFormData]);

  return (
    <>
      <form id='acronym-form' onSubmit={handleSubmit}>
        <Grid container rowSpacing={2} sx={{ mb: 2, width: "500px" }}>
          <Grid item xs={12}>
            <TextField
              required
              label='Acronym'
              variant='outlined'
              fullWidth
              value={formData.acronym}
              onChange={(e) => handleChange("acronym", e.target.value)}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label='Full Form'
              variant='outlined'
              fullWidth
              value={formData.fullForm}
              onChange={(e) => handleChange("fullForm", e.target.value)}
              inputProps={{ maxLength: 255 }}
              multiline
              rows={3}
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant='outlined' onClick={handleDialogClose} sx={{ mr: 1 }}>
            Cancel
          </Button>
          {acronymFormType === ADMIN.MEETING_FORM_TYPE.EDIT ? (
            <Button variant='contained' type='submit' disabled={formLoading}>
              Update
            </Button>
          ) : (
            <Button variant='contained' type='submit' disabled={formLoading}>
              Create
            </Button>
          )}
        </Box>
      </form>
    </>
  );
};

export default AcronymForm;

